// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__uSB1X","title":"Images90_title__2mAsA","images":"Images90_images__2wCoH"};